module.exports = __webpack_public_path__ + "static/media/camera-retro.a2b33124.svg";